"use client"
import { useState, useEffect } from "react"
import LandingPage from "./pages/LandingPage"
import RegistrationPage from "./pages/RegistrationPage"
import AssessmentPage from "./pages/AssessmentPage"
import ReportPage from "./pages/ReportPage"
import ThankYouPage from "./pages/ThankYouPage"

function App() {
  const [currentStep, setCurrentStep] = useState("landing")
  const [userData, setUserData] = useState({})
  const [assessmentData, setAssessmentData] = useState({})

  // Load data from sessionStorage on component mount
  useEffect(() => {
    const savedUserData = sessionStorage.getItem("gtm_user_data")
    const savedAssessmentData = sessionStorage.getItem("gtm_assessment_data")
    const savedStep = sessionStorage.getItem("gtm_current_step")
    if (savedUserData) {
      setUserData(JSON.parse(savedUserData))
    }
    if (savedAssessmentData) {
      setAssessmentData(JSON.parse(savedAssessmentData))
    }
    if (savedStep) {
      setCurrentStep(savedStep)
    }
  }, [])

  // Save data to sessionStorage whenever it changes
  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      sessionStorage.setItem("gtm_user_data", JSON.stringify(userData))
    }
  }, [userData])

  useEffect(() => {
    if (Object.keys(assessmentData).length > 0) {
      sessionStorage.setItem("gtm_assessment_data", JSON.stringify(assessmentData))
    }
  }, [assessmentData])

  useEffect(() => {
    sessionStorage.setItem("gtm_current_step", currentStep)
  }, [currentStep])

  const handleStepChange = (step) => {
    setCurrentStep(step)
  }

  const handleUserDataUpdate = (data) => {
    setUserData(data)
  }

  const handleAssessmentDataUpdate = (data) => {
    setAssessmentData(data)
  }

  const resetAssessment = () => {
    setCurrentStep("landing")
    setUserData({})
    setAssessmentData({})
    sessionStorage.removeItem("gtm_user_data")
    sessionStorage.removeItem("gtm_assessment_data")
    sessionStorage.removeItem("gtm_current_step")
  }

  const renderCurrentStep = () => {
    switch (currentStep) {
      case "landing":
        return <LandingPage onNext={() => handleStepChange("registration")} />
      case "registration":
        return (
          <RegistrationPage
            userData={userData}
            onNext={() => handleStepChange("assessment")}
            onBack={() => handleStepChange("landing")}
            onUserDataUpdate={handleUserDataUpdate}
          />
        )
      case "assessment":
        return (
          <AssessmentPage
            userData={userData}
            assessmentData={assessmentData}
            onNext={() => handleStepChange("thankyou")}
            onBack={() => handleStepChange("registration")}
            onAssessmentDataUpdate={handleAssessmentDataUpdate}
          />
        )
      case "thankyou":
        return <ThankYouPage userData={userData} assessmentData={assessmentData} onReset={resetAssessment} />
      default:
        return <LandingPage onNext={() => handleStepChange("registration")} />
    }
  }

  return <div className="min-h-screen bg-white">{renderCurrentStep()}</div>
}

export default App